import React from 'react'
import './ArticleList.css'
import { Button } from '@material-ui/core'


function ArticleList({ recievedArticles }) {

    return (
        <div className="article-main">
            {
                recievedArticles.map((article, i) => {
                    const placeHolder = article.description;
                    const articleDescription = placeHolder.replace(/<\/?[^>]+(>|$)/g, '');

                    return (
                        <div key={i} className="article-item">
                            <div className="article-item-flex">
                                <div className="text-part">
                                    <h3 className="title" > {article.title}  </h3>
                                    <p className="description" > {articleDescription} </p>


                                    <div className="button-div">
                                        <Button size="small" variant="contained" color="secondary" href={article.url} target="_blank"  >
                                            Read full article
                                        </Button>
                                    </div>
                                </div>

                                <div className="img-div">
                                    <img src={article.image} alt="news" />
                                </div>
                            </div>

                        </div>
                    )
                })
            }
        </div>
    )
}

export default ArticleList;
